import styled from 'styled-components';
import {mediumMedia, scrollbar} from '../../../../../globalVariables/GlobalVariables';
import {dFlex, flexRowReverse, flexColumn, flexNoWrap, alignCenter, alignStart, alignStretch, justifyCenter} from '../../../../../globalVariables/GlobalFlex';
import {getColor} from '../../../utils/themeUtils';
import {getEventDetailsBackground} from '../../../style.css';

export const card = styled.div`
    grid-area: details;
    position: relative;
    ${getEventDetailsBackground};
    border-radius: var(--radius-xl);
    padding: var(--space-2xl);
    ${dFlex}
    ${flexRowReverse}
    ${alignCenter}
    gap: var(--space-lg);
    [data-cy='account-menu-sublist'],
    [data-cy='account-switcher'] {
        scrollbar-width: none;
        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
    }
    [data-cy='account-switcher'] button {
        border-bottom: none;
    }
    ${mediumMedia}{
        ${flexColumn}
        ${alignStretch}
        padding: var(--space-lg) 0;
    }
`;

export const menu = styled.div`
    ${dFlex}
    ${alignStart}
    gap: var(--space-sm);
    ${mediumMedia}{
        order: 3;
        justify-content: safe center;
        padding-inline: var(--space-lg);
        ${scrollbar};
    }
`;

export const nameBlock = styled.div`
    flex: 1;
    align-self: stretch;
    ${dFlex}
    ${flexColumn}
    ${justifyCenter}
    gap: var(--space-xs);
    color: ${p => getColor(p.theme.isDarkMode)};
    ${mediumMedia}{
        order: 1;
        flex: none;
        padding-inline: var(--space-lg);
    }
`;

export const nameLabel = styled.div`
    line-height: 1.3;
    font-size: var(--font-size-h2);
    font-weight: var(--font-weight-normal);
    ${mediumMedia}{
        font-size: var(--dimension-5);
    }
`;

export const nameRow = styled.div`
    ${dFlex}
    ${flexNoWrap}
    ${alignCenter}
    gap: var(--space-sm);
`;

export const labelRow = styled.div`
    ${dFlex}
    ${flexNoWrap}
    ${alignCenter}
    gap: var(--space-lg);
`;

export const nameText = styled.div`
    line-height: 1;
    font-size: var(--dimension-8);
    font-weight: var(--font-weight-semibold);
    ${mediumMedia}{
        font-size: var(--dimension-6);
    }
`;

export const accountNumber = styled.div`
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-normal);
`;
